import { FormGroup, ValidatorFn } from "@angular/forms";

export function equalFields(firtsField: string, secondField: string): ValidatorFn{
    return (form: FormGroup): { [key: string]: boolean } | null => {
        const firtsFieldValue = form.get(firtsField).value;
        const secondFieldValue = form.get(secondField).value;

        if(firtsFieldValue === secondFieldValue) {
            const err = { fieldsAreEqual: true };
            form.get(secondField).setErrors(err);
            return err;
        }
        else {
            const fieldError = form.get(secondField).hasError('fieldsAreEqual');
            if(fieldError) {
                delete form.get(secondField).errors['fieldsAreEqual'];
                form.get(secondField).updateValueAndValidity();
            }
        }
    };
}